// Import the Patientv2 interface
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid2 } from '@mui/material';
import { Patientv2 } from '../../../types';
import { EMPTY_PLACEHOLDER, getDateInDDMMYYYY, toTitleCase } from '../../../utils/commonUtils';

interface PatientDetailsProps {
  selectedPatientDetails: Patientv2; // Use Patientv2 interface 
}

const PatientDetails: React.FC<PatientDetailsProps> = ({ selectedPatientDetails }) => {
  const { t: tGeneral } = useTranslation('general');
  const { t: tRegistration } = useTranslation('registration_lang');
  const { t: tAppointment } = useTranslation('appointment_form');

  return (
    <>
      <Grid2 container spacing={2} mx={1} my={1} pl={2} width={'100%'}>
        <Grid2 size={{xs: 3, lg:3}}>
          <strong>{tRegistration('Registration.Text_First_Name', 'First Name')}</strong>
          <div>{selectedPatientDetails.first_name}</div>
        </Grid2>

        <Grid2 size={{xs: 3, lg:3}}>
          <strong>{tRegistration('Registration.Text_Last_Name', 'Last Name')}</strong>
          <div>{selectedPatientDetails.last_name}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>{tGeneral('Text_DOB', 'DOB')}</strong>
          <div>{getDateInDDMMYYYY(selectedPatientDetails.date_of_birth)}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>{tGeneral('Sex Assigned at Birth', 'Sex Assigned At Birth')}</strong>
          <div>{toTitleCase(selectedPatientDetails.gender)}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>{tGeneral('MRN_No', 'MRN')}</strong>
          <div>{selectedPatientDetails.medical_record_no || EMPTY_PLACEHOLDER}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>{tRegistration('Registration.Text_Phone_Number', 'Phone Number')}</strong>
          <div>{selectedPatientDetails.mobile_number_country_code && selectedPatientDetails.mobile_number ? `${selectedPatientDetails.mobile_number_country_code.startsWith('+') ? '' : '+'}${selectedPatientDetails.mobile_number_country_code}-${selectedPatientDetails.mobile_number}` : '+00-0000000000'}</div>
        </Grid2>

        <Grid2 size={{xs: 3}}>
          <strong>{tRegistration('Registration.Text_EmailId', 'Email ID')}</strong>
          <div>{selectedPatientDetails?.alternate_email || ''}</div>
        </Grid2>
      </Grid2>

      {selectedPatientDetails.partner && ( // Check if partner details exist
        <Grid2 container spacing={2} mx={1} my={1} pl={2} width={'100%'}>
          <Grid2 size={{xs: 3}}>
            <strong>{ tAppointment('partnerFirstNameLabel', 'Partner First Name')}</strong>
            <div>{selectedPatientDetails.partner.first_name}</div>
          </Grid2>

          <Grid2 size={{xs: 3}}>
            <strong>{ tAppointment('partnerLastNameLabel', 'Partner Last Name')}</strong>
            <div>{selectedPatientDetails.partner.last_name}</div>
          </Grid2>

          <Grid2 size={{xs: 3}}>
            <strong>{tRegistration('Partner DOB', 'Partner DOB')}</strong>
            <div>{getDateInDDMMYYYY(selectedPatientDetails.partner.date_of_birth)}</div>
          </Grid2>

          <Grid2 size={{xs: 3}}>
            <strong>{tGeneral('Sex Assigned At Birth', 'Sex Assigned At Birth')}</strong>
            <div>{toTitleCase(selectedPatientDetails.partner.gender)}</div>
          </Grid2>
        </Grid2>
      )}
    </>

  );
};

export default PatientDetails;
